import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page0Pc from './Page0Pc'
import Page0Mobile from './Page0Mobile'
import React, { useEffect, useState } from 'react'
import { selectMainBanner } from '../../api/x_banner'

function Page0() {
  const [banner, setBanner] = useState([])
  useEffect(() => {
    async function fetchBanner() {
      const response = await selectMainBanner({ code: 'BANNER_01' })
      const data = response.data.data
      setBanner(data)
    }
    fetchBanner()
  }, [])
  return (
    <>
      <Pc>
        <Page0Pc banner={banner} />
      </Pc>
      <Mobile>
        <Page0Mobile banner={banner} />
      </Mobile>
    </>
  )
}

export default Page0
